export function parseTargetColumnMapping(mappingStr: string | null | undefined): Record<string, string> {
  if (!mappingStr) {
    return {};
  }

  try {
    let cleanedStr = mappingStr.trim();
    
    // Remove surrounding quotes
    cleanedStr = cleanedStr.replace(/^"+|"+$/g, '');
    
    // Remove surrounding braces
    if (cleanedStr.startsWith('{') && cleanedStr.endsWith('}')) {
      cleanedStr = cleanedStr.substring(1, cleanedStr.length - 1);
    }

    const result: Record<string, string> = {};
    if (cleanedStr.trim() === '') {
      return result;
    }

    const pairs = cleanedStr.split(',');
    for (const pair of pairs) {
      const parts = pair.split('=');
      if (parts.length >= 2) {
        const key = parts[0].trim();
        const value = parts.slice(1).join('=').trim();
        if (key) {
          result[key] = value;
        }
      }
    }

    return result;
  } catch (err) {
    console.warn('Error parsing target column mapping:', err);
    return {};
  }
}
